import React from 'react';
import { getFirebaseToken } from '@utilities/firebase/firebaseConfigs';
import { useNotificationPermission } from '../useNotificationPermission/useNotificationPermission';

export const useGetNotificationToken = () => {
	const [notificationToken, setNotificationToken] = React.useState<string | null>(null);
	const isMountedRef = React.useRef(true);
	const { hasNotificationPermission } = useNotificationPermission();

	React.useEffect(() => {
		if (!hasNotificationPermission) {
			setNotificationToken(null);
			return;
		}
		isMountedRef.current = true;

		const initializeToken = async () => {
			if (!isMountedRef.current) return;

			const token = await getFirebaseToken();
			if (isMountedRef.current) setNotificationToken(token);
		};

		void initializeToken();

		return () => {
			isMountedRef.current = false;
		};
	}, [hasNotificationPermission]);

	return { notificationToken };
};
